import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  font: {
    fontSize: "1rem",
  },
  totalNumberBox: {
    backgroundColor: "#FAF7F7",
    padding: theme.spacing(1),
    borderRadius: "5px",
    color: "#00003D",
    textAlign: "right",
  },
  totalBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1),
    marginBottom: "5px",
  },
  dataRow: {
    padding: theme.spacing(1),
    marginTop: "5px",
    marginBottom: "5px",
    color: "#00003D",
    display: "flex",
    justifyContent: "space-between",
  },
  blueTitles: {
    textAlign: "left",
    color: "#00003D",
    fontWeight: "bold",
  },
  addButton: {
    color: theme.palette.error.main,
    textTransform: "capitalize",
  },
}))

export default styles
